module.exports = __webpack_public_path__ + "static/multicopter-61a73266fb0e2d886d27930c1a6f06ae.jpg";